"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _withWrapper = _interopRequireDefault(require("../withWrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _withWrapper.default)('Redo', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("g", {
    stroke: "none",
    strokeWidth: props.strokeWidth,
    fill: "none",
    fillRule: "evenodd"
  }, _react.default.createElement("g", null, _react.default.createElement("g", {
    transform: "translate(24.000000, 24.000000) scale(-1, 1) translate(-24.000000, -24.000000) translate(6.000000, 6.000000)",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }, _react.default.createElement("path", {
    d: "M5.27207794,30.7279221 C8.52943725,33.9852814 13.0294373,36 18,36 C27.9411255,36 36,27.9411255 36,18 C36,8.0588745 27.9411255,7.10542736e-15 18,7.10542736e-15 C13.0294373,7.10542736e-15 8.52943725,2.01471863 5.27207794,5.27207794 C4.16674151,6.37741436 2.4093822,8.28672172 1.0658141e-14,11"
  }), _react.default.createElement("polyline", {
    points: "8.8817842e-16 2 8.8817842e-16 11 9 11"
  })))));
});

exports.default = _default;